import React from "react";
import IconContainer from "./IconContainer";

import {
	Article,
	Book,
	BookLg,
	Bookmark,
	BookMarkLg,
	BookmarkFilled,
	Calendar,
	CarrotUp,
	CarrotDown,
	Check,
	CheckLg,
	Close,
	ColorGradient,
	ColorGradientLg,
	Document,
	DocumentLg,
	Education,
	EducationLg,
	Event,
	EventLg,
	Hamburger,
	Location,
	LocationLg,
	Membership,
	MembershipLg,
	Play,
	Quote,
	Rainbow,
	Star,
	Search,
	StarLg,
	Smile,
	SmileLg,
	Thumb,
	ThumbLg,
	Triangle,
} from "./icons";

function Icon(props) {
	let Icon;
	const _icon = props.icon;
	const isLarge = props.size === "lg";

	//Icon styles
	// const iconStyle = props.iconStyle;
	switch (_icon) {
		case "article":
			Icon = Article;
			break;
		case "book":
			if (isLarge) Icon = BookLg;
			else Icon = Book;
			break;

		case "bookmark":
			if (isLarge) Icon = BookMarkLg;
			else Icon = Bookmark;

			break;

		case "bookmarkFilled":
			Icon = BookmarkFilled;
			break;
		case "calendar":
			Icon = Calendar;
			break;
		case "carrotDown":
			Icon = CarrotDown;
			break;
		case "carrotUp":
			Icon = CarrotUp;
			break;
		case "check":
			if (isLarge) Icon = CheckLg;
			else Icon = Check;
			break;
		case "close":
			Icon = Close;
			break;
		case "colorGradient":
			if (isLarge) Icon = ColorGradientLg;
			else Icon = ColorGradient;
			break;
		case "document":
			if (isLarge) Icon = DocumentLg;
			else Icon = Document;
			break;
		case "education":
			if (isLarge) Icon = EducationLg;
			else Icon = Education;
			break;
		case "event":
			if (isLarge) Icon = EventLg;
			else Icon = Event;
			break;
		case "hamburger":
			Icon = Hamburger;
			break;
		case "location":
			if (isLarge) Icon = LocationLg;
			else Icon = Location;
			break;
		case "membership":
			if (isLarge) Icon = MembershipLg;
			else Icon = Membership;
			break;
		case "play":
			Icon = Play;
			break;
		case "quote":
			Icon = Quote;
			break;

		case "rainbow":
			Icon = Rainbow;
			break;
		case "smile":
			if (isLarge) Icon = SmileLg;
			else Icon = Smile;
			break;
		case "search":
			// if (isLarge) Icon = SearchLg;
			// else
			Icon = Search;
			break;

		case "star":
			if (isLarge) Icon = StarLg;
			else Icon = Star;
			break;
		case "thumb":
			if (isLarge) Icon = ThumbLg;
			else Icon = Thumb;
			break;
		case "triangle":
			Icon = Triangle;
			break;
		default:
			break;
	}

	return (
		<IconContainer className={props.className} style={{ ...props.style }}>
			<Icon iconProps={props.iconProps} color={props.color} />
		</IconContainer>
	);
}

export { Check, Location, Play, Education, Star, Triangle, Calendar, Icon };
